import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */

	function view() {
		appContext.navTo({
			item: 'side-view',
			subItem: 'subject-options',
			extraItem: data.uuid,
		})
	}

	return (
		<div className="One" onClick={view}>
			<div className="row">

				<div className="col-12">
					<h6
						style={{
							fontSize: "24px"
						}}
						className="font-light"
					>
						{data.name}
					</h6>

					<h6
						style={{
							fontSize: "16px"
						}}
						className="font-semi-bold"
					>
						{(data.classroomData) ? data.classroomData.name : ""}
						{(data.streamData) ? data.streamData.name : ""}
					</h6>
				</div>
				
				

			</div>
		</div>
	)

}